import styled from "styled-components";
import { MOBILE_WIDTH, TABLET_WIDTH } from "datastake-daf/src/constants/Style";

export default styled.div`
  .container-p {
    padding-left: 10vw;
    padding-right: 10vw;

    @media (max-width: 1440px) {
      padding-left: 72px;
      padding-right: 72px;
    }

    @media (${TABLET_WIDTH}) {
      padding-left: 2.3rem;
      padding-right: 2.3rem;
    }
  }

  .app-footer {
    padding-top: 6.25rem;
    background-color: #132735;
  
    @media (${MOBILE_WIDTH}) {
      padding-top: 4.32rem;
    }
  
    .top {
      padding-bottom: 3rem;
      border-bottom: 2px solid #7789a1;
  
      img {
        width: 2.5rem;
        margin-bottom: 1.5rem;
      }
  
      h1 {
        font-size: 1.875rem;
        font-weight: 600;
        color: white;
        line-height: 2.8125rem;
        margin-bottom: 1.5rem;
  
        @media (${MOBILE_WIDTH}) {
          margin-bottom: 2.72rem;
        }
      }
  
      .links {
        gap: 3rem;
        display: flex;
  
        a {
          color: #92A6B9;
          font-size: 1.2rem;
          line-height: 1.5rem;
        }
  
        @media (${MOBILE_WIDTH}) {
          flex-direction: column;
          text-align: left;
          gap: 2.2rem;
  
          a {
            font-size: 1.12rem;
          }
        }
      }
    }
  
    .bottom-f {
      padding: 1.5rem 0;
      display: flex;
  
      .left {
        flex: 1;
  
        span {
          color: #98A2B3;
  
          @media (${MOBILE_WIDTH}) {
            font-size: 1.28rem;
          }
        }
      }
  
      svg {
        width: var(--size-lg);
        height: var(--size-lg);
  
        @media (${MOBILE_WIDTH}) {
          width: 1.92rem;
          height: 1.92rem;
        }
      }
  
      .right {
        display: flex;
        gap: 1.84rem;
  
        @media (${MOBILE_WIDTH}) {
          gap: 1.5rem;
        }
  
        svg {
          cursor: pointer;
  
          @media (${MOBILE_WIDTH}) {
            width: var(--size-lg);
          }
        }
      }
    }
  }
  
`;
